import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import defaultThumb from "../../../../assets/VZY/default.png";
import play from "../../../../assets/VZY/play.svg";
import { useNavigate } from "react-router-dom";
import { SelfhelpVideos } from "../../help_support/components/SelfhelpVideos";
import { BrowserView, MobileView } from "react-device-detect";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const PAGE_SIZE = 5;

export const RealtedVideo = ({ contentItem }) => {
  const apiBaseURL = process.env.REACT_APP_API_URL || window.location.origin;
  const { state } = useLocation();
  const [realtedVideoItems, setRealtedVideoItems] = useState([]);
  const navigate = useNavigate();

  const fetchRelatedVideos = useCallback(async () => {
    try {
      const payload = {
        ContentCode: "",
        ContentTypeID: contentItem || 2,
        CategoryID: 0,
        IsActive: 1,
        PageNumber: 1,
        pageSize: PAGE_SIZE,
        SearchValue: "",
      };

      const response = await axios.post(
        `${apiBaseURL}/api/VZYHelpSupport/FetchRelatedVideo`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );

      setRealtedVideoItems(response?.data?.result?.relatedVideos ?? []);
    } catch (err) {
      console.error("FetchRelatedVideos error:", err);
    }
  }, [apiBaseURL, contentItem]);

  useEffect(() => {
    fetchRelatedVideos();
  }, [fetchRelatedVideos]);

  const formatCategoryForUrl = useCallback((value = "") => {
    return value
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  }, []);

  const truncateText = useCallback((text = "", maxLength = 30) => {
    if (text.length <= maxLength) return text;
    return `${text.slice(0, maxLength)}…`;
  }, []);

  const handleRoute = (itemDetails) => {
    const formattedCategory = formatCategoryForUrl(
      itemDetails?.contentCategoryName,
    );

    navigate(`/VZYSupport/video/${formattedCategory || "notFound"}`, {
      state: { detailsIDs: itemDetails },
    });
  };

  if (!Array.isArray(realtedVideoItems) || realtedVideoItems.length === 0) {
    return <p className="no-data-text">No videos available</p>;
  }

  const renderVideoCard = (video) => {
    const fullTitle = video?.contentTitle || "Untitled Video";
    const displayTitle = truncateText(fullTitle, 30);

    return (
      <div
        className="vzy-video-card"
        role="button"
        tabIndex={0}
        onClick={() => handleRoute(video)}
        onKeyDown={(e) => e.key === "Enter" && handleRoute(video)}
      >
        <div className="video-thumbnail">
          <img
            src={video?.thumbnailUrl || defaultThumb}
            alt={fullTitle}
            onError={(e) => (e.currentTarget.src = defaultThumb)}
          />
          <div className="play-overlay">
            <img src={play} alt="Play video" />
          </div>
        </div>

        <h6 className="video-title" title={fullTitle}>
          {displayTitle}
        </h6>
      </div>
    );
  };

  return (
    <>
      <BrowserView className="sidebar-related-video">
        {realtedVideoItems.map((video, index) => (
          <div className="col-video-4" key={video?.id ?? index}>
            {renderVideoCard(video)}
          </div>
        ))}
      </BrowserView>

      <MobileView className="sidebar-related-video">
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          loop
          centeredSlides
          slidesPerView={1.3}
          spaceBetween={12}
          className="col-video-4"
        >
          {realtedVideoItems.map((video, index) => (
            <SwiperSlide key={video?.id ?? index}>
              {renderVideoCard(video)}
            </SwiperSlide>
          ))}
        </Swiper>
      </MobileView>
    </>
  );
};
